import { scale } from '@utils/normalize';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  btnWhatsappStyles: { height: 48, marginRight: scale(8) },
});
export default styles;
